export enum FEATURE_FLAG_VARIANTS {
  /** @public valid domain value representing a disabled flag state */
  Disabled = `disabled`,
  Enabled = `enabled`,
  Treatment = `treatment`,
}

export enum FlagType {
  FEATURE_GATE = `FEATURE_GATE`,
  DYNAMIC_CONFIG = `DYNAMIC_CONFIG`,
  EXPERIMENT = `EXPERIMENT`,
}

export enum VariantValueType {
  STRING = `string`,
  DYNAMIC = `json`,
}

export enum FlagStatus {
  DRAFT = `draft`,
  DISABLED = `disabled`,
  ENABLED = `enabled`,
  ARCHIVED = `archived`,
}
